import { render, staticRenderFns } from "./EmailColumn.vue?vue&type=template&id=078578ea&"
import script from "./EmailColumn.vue?vue&type=script&lang=js&"
export * from "./EmailColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports